export enum ScrollQuestionInStudentResult {
	MIN_SCROLL = 1,
	MAX_DISPLAY = 10
}